import React from 'react';
import {
    contextSelectorDispatch,
    contextSelectors,
} from '@klp/contextSelector';
import { ActionButton, Tooltip } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import type { Theme } from '@material-ui/core';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    selectedItem: {
        display: 'flex',
        alignItems: 'center',
    },
    shortText: {
        maxWidth: theme.sidebar.open.contentWidth,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
});

export const SelectedContextSidebar: React.FC = () => {
    const { selectedContext } = useSelector(contextSelectors);
    const { clearSelectedContextFromStorage } =
        contextSelectorDispatch(useDispatch());

    const classes = useKlpStyles({}, styles);

    if (!selectedContext?.nummer) return null;

    return (
        <ListItem component="div" className={classes.selectedItem}>
            <ListItemIcon>
                <Illustration icon={IconName.HOUSE} klpColor="veryLight" />
            </ListItemIcon>

            <ListItemText>
                <Tooltip title={selectedContext?.navn}>
                    <ActionButton
                        actionType="cancel"
                        onClick={clearSelectedContextFromStorage}
                        className="Sidebar__StandaloneButton"
                        variant="outlined"
                        size="medium"
                    >
                        <span className={classes.shortText}>
                            {selectedContext?.navn}
                        </span>
                    </ActionButton>
                </Tooltip>
            </ListItemText>
        </ListItem>
    );
};
